import { Field } from 'ngx-angular-query-builder';
import { FilterOperators, FieldMetadataCollection, FilterFieldProvider, FieldMetadataCollectionBuilder } from '@common/filter/filtering';
import { IRow, ITable } from '@common/models/table';
import { ArrayToFilterListItemBuilder, asDate, mapDate } from '@common/filter/services/array-to-filter-list-item-builder';


export class CallsWidgetFilterFieldProvider implements FilterFieldProvider {

  private readonly fieldMetaDataCollection = new FieldMetadataCollection();

  constructor(private readonly tableData: ITable,
    private readonly product: string) {

    const fieldMetaDataBuilder = new FieldMetadataCollectionBuilder(this.fieldMetaDataCollection);
    const optionBuilder = new ArrayToFilterListItemBuilder(tableData ? tableData.Rows : []);
    const sysOption = (s: string) => optionBuilder.forProperty(s, s, (x: IRow) => x[s]);

    optionBuilder.add('SystemLoggedDate', (x: any) => asDate(x.SystemEffectiveDate), mapDate('SystemLoggedDate'));
    sysOption('SystemCallReference');
    sysOption('SystemPropertyRef');
    sysOption('SystemUnitRef');
    sysOption('SystemUnitAddress');
    sysOption('SystemLeaseRef');
    sysOption('SystemTenantRef');
    sysOption('SystemReplyEmail');
    sysOption('SystemNotified');
    sysOption('SystemSubject');
    sysOption('SystemMessage');
    sysOption('SystemAttachedDocuments');
    sysOption('SystemComments');
    sysOption('SystemStatus');
    sysOption('SystemClosedDate');

    const options = optionBuilder.build();

    const addFilter = (label: string,
      optionsName: string,
      type: string,
      ops: string[]) => fieldMetaDataBuilder.add(label, optionsName, type, ops, options.get(optionsName));

    addFilter('Call Reference', 'SystemCallReference', 'number', FilterOperators.Scalar);
    addFilter('Logged Date', 'SystemLoggedDate', 'date', FilterOperators.DateDefaults);
    addFilter('Property Ref', 'SystemPropertyRef', 'number', FilterOperators.Scalar);
    addFilter('Unit Ref', 'SystemUnitRef', 'number', FilterOperators.Scalar);
    addFilter('Unit Address (Strung)', 'SystemUnitAddress', 'string', FilterOperators.StringDefaults);
    addFilter('Lease Ref', 'SystemLeaseRef', 'number', FilterOperators.Scalar);
    addFilter('Tenant Ref', 'SystemTenantRef', 'number', FilterOperators.Scalar);
    addFilter('Tenant Name', 'SystemTenantName', 'string', FilterOperators.StringDefaults);
    addFilter('Reply Email', 'SystemReplyEmail', 'string', FilterOperators.StringDefaults);
    addFilter('Notified', 'SystemNotified', 'string', FilterOperators.StringDefaults);
    addFilter('Subject', 'SystemSubject', 'string', FilterOperators.StringDefaults);
    addFilter('Message', 'SystemMessage', 'string', FilterOperators.StringDefaults);
    addFilter('Attached Documents', 'SystemAttachedDocuments', 'string', FilterOperators.StringDefaults);
    addFilter('Comments', 'SystemComments', 'string', FilterOperators.StringDefaults);
    addFilter('Status', 'SystemStatus', 'string', FilterOperators.StringDefaults);
    addFilter('Closed Date', 'SystemClosedDate', 'date', FilterOperators.DateDefaults);
  }

  getFilterFields(): Array<Field> {
    return this.fieldMetaDataCollection.getFilterFields();
  }

  getFieldNameFromLabel(label: string): string {
    return this.fieldMetaDataCollection.getFieldNameFromLabel(label);
  }

  getFilterField(fieldName: string): Field {
    return this.fieldMetaDataCollection.getFilterField(fieldName);
  }


}
